import { PutTripDatesType } from '@orbit/api-types'
import { usePut } from '@hooks/useApi'
import { queryKeys } from '@lib/queryKeys'
import { useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'

interface UpdateTripDatesParams {
	startDate: string // YYYY-MM-DD format
	endDate: string // YYYY-MM-DD format
}

export const useUpdateTripDates = (tripId: string) => {
	const queryClient = useQueryClient()

	return usePut<PutTripDatesType, Trip>(`/trips/${tripId}/tripDates`, {
		onSuccess: updatedTrip => {
			queryClient.invalidateQueries({ queryKey: queryKeys.trip(tripId) })
			queryClient.invalidateQueries({ queryKey: queryKeys.trips() })
			queryClient.invalidateQueries({ queryKey: queryKeys.events(tripId) })
			queryClient.setQueryData(queryKeys.trip(tripId), updatedTrip)
		},
	})
}

// Helper function to convert date range to API payload
export const convertDateRangeToPayload = (params: UpdateTripDatesParams): PutTripDatesType => {
	// Convert YYYY-MM-DD to YYYYMMDD format
	const startDateYYYYMMDD = params.startDate.replace(/-/g, '')

	// Calculate day count
	const startDate = new Date(params.startDate)
	const endDate = new Date(params.endDate)
	const dayCount = Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)) + 1

	return {
		startDate: startDateYYYYMMDD,
		dayCount,
	}
}
